import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';
import { loginDPRoot } from '../../login-meta';

const dpRoot = `${loginDPRoot}|Forgot Password`;

const sharedProps: Pick<LocDef, 'portal' | 'shared'> = {
	portal: 'CP',
	shared: false,
};

export type ForgotPasswordLoc =
	| 'CPForgotPasswordMethod'
	| 'CPLoginEmailField'
	| 'CPLoginUsernameField'
	| 'CPLoginUsernameError'
	| 'CPLoginEmailRequired'
	| 'CPForgotPasswordSubmit'
	| 'CPForgotPasswordCancel'
	| 'CPForgotPasswordRequestConfirmation'
	| 'CPForgotPasswordRequestConfirmationFailure'
	| 'CPForgotPasswordPageTitle';

export const forgotPasswordLocs: LocDefs<ForgotPasswordLoc> = {
	CPForgotPasswordMethod: {
		defaultValue: 'Reset password using',
		description:
			'Label for the dropdown to select how the candidate would like to reset password',
		displayPath: `${dpRoot}|Method`,
		displayType: 'Label',
		feature: HubFeature.CandidateAccessLoginEmail,
		...sharedProps,
	},
	CPLoginEmailField: {
		defaultValue: 'Email',
		description: 'Label for the email field',
		displayPath: `${dpRoot}|Email Field`,
		displayType: 'Label',
		feature: HubFeature.CandidateAccessLoginEmail,
		...sharedProps,
	},
	CPLoginUsernameField: {
		defaultValue: 'Username',
		description: 'Label for the username field',
		displayPath: `${dpRoot}|Username Field`,
		displayType: 'Label',
		feature: HubFeature.CandidateAccessLogin,
		...sharedProps,
	},
	CPLoginUsernameError: {
		defaultValue: 'Please enter your username',
		description: 'Error saying that the username is required.',
		displayPath: `${dpRoot}|Username Error`,
		displayType: 'Error',
		feature: HubFeature.CandidateAccessLogin,
		...sharedProps,
	},
	CPLoginEmailRequired: {
		defaultValue: 'Please enter your email',
		description: 'Error message if email field is empty',
		displayPath: `${dpRoot}|Email Required`,
		displayType: 'Error',
		feature: HubFeature.CandidateAccessLoginEmail,
		...sharedProps,
	},
	CPForgotPasswordSubmit: {
		defaultValue: 'Submit',
		description: 'The submit button text for the forgot password feature on the login page.',
		displayPath: `${dpRoot}|Submit`,
		displayType: 'Button',
		feature: HubFeature.CandidateAccessLogin,
		...sharedProps,
	},
	CPForgotPasswordCancel: {
		defaultValue: 'Cancel',
		description: 'The cancel button text for the forgot password feature on the login page.',
		displayPath: `${dpRoot}|Cancel`,
		displayType: 'Button',
		feature: HubFeature.CandidateAccessLogin,
		...sharedProps,
	},
	CPForgotPasswordRequestConfirmation: {
		defaultValue:
			'If the information entered is valid, an email will be sent to your email address which contains information that will allow you to log into the system. If the email does not arrive within 2 hours please check your spam folder.',
		description:
			'The confirmation text for when a password reset was successfully requested when using the forgot password feature on the login page.',
		displayPath: `${dpRoot}|Request Confirmation`,
		displayType: 'Content',
		feature: HubFeature.CandidateAccessLogin,
		htmlAllowed: true,
		...sharedProps,
	},
	CPForgotPasswordRequestConfirmationFailure: {
		defaultValue:
			'If the information entered is valid, an email will be sent to your email address which contains information thatIf the information entered is valid, an email will be sent to your email address which contains information that will allow you to log into the system. If the email does not arrive within 2 hours please check your spam folder.',
		description:
			'Contents of the confirmation message shown to candidates whose forgot password request does not succeed.',
		displayPath: `${dpRoot}|Failure`,
		displayType: 'Content',
		feature: HubFeature.CandidateAccessLogin,
		htmlAllowed: true,
		...sharedProps,
	},
	CPForgotPasswordPageTitle: {
		defaultValue: 'Forgot Password',
		description: 'Page title for the forgot password page',
		displayPath: `${dpRoot}|Page Title`,
		displayType: 'Title',
		feature: HubFeature.CandidateAccessLogin,
		...sharedProps,
	},
};

export const LOC_KEYS = MapLocKeys<ForgotPasswordLoc>(forgotPasswordLocs);
